import {FuturePurchaseOptions as FuturePurchaseOptionsLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

export type FuturePurchaseOptionsProps = {
  futurePurchaseOptionsLetter: FuturePurchaseOptionsLetter;
};

const FuturePurchaseOptions = (props: FuturePurchaseOptionsProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.futurePurchaseOptionsLetter.date)} />
      <CardField name="Amount Increase" value={toMoneyValue(props.futurePurchaseOptionsLetter.amountIncrease)} />
      <CardField name="Effective Date" value={toFormattedDateAsUTC(props.futurePurchaseOptionsLetter.effectiveDate)} />
      <CardField name="Frequency" value={props.futurePurchaseOptionsLetter.frequency} />
      <CardField name="Insured Name" value={props.futurePurchaseOptionsLetter.insuredName} ddprivacy="mask"/>
      <CardField name="Owner Name" value={props.futurePurchaseOptionsLetter.ownerName} ddprivacy="mask"/>
      <CardField name="Owner Address" value={props.futurePurchaseOptionsLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Policy Number" value={props.futurePurchaseOptionsLetter.policyNumber} ddprivacy="mask"/>
      <CardField name="Premium Amount" value={toMoneyValue(props.futurePurchaseOptionsLetter.premiumAmount)} />
    </>
  );
};

export default FuturePurchaseOptions;
